const KEY = 'tenant_cached';
export function cacheTenant(value) {
    const data = { value: value.trim(), ts: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(data));
}
export function readTenant() {
    const raw = localStorage.getItem(KEY);
    if (!raw)
        return null;
    try {
        const { value } = JSON.parse(raw);
        return value?.trim() || null;
    }
    catch {
        return null;
    }
}
export function clearCachedTenant() {
    localStorage.removeItem(KEY);
}
